// extracted by mini-css-extract-plugin
export default {"otp-field-input":"OtpField_otp-field-input__cqxeu"};